import React, { createContext, useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import Book from './components/Dashboard/Book/Book';
import BookingList from './components/Dashboard/BookingList/BookingList';
import Dashboard from './components/Dashboard/Dashboard/Dashboard';
import Home from './components/Home/Home/Home';
import Login from './components/Login/Login/Login';
import Oil from './components/Oil/Oil/Oil';
import Ipone from './components/OilChange/Ipone/Blog/Blog';
import Motul from './components/OilChange/Motul/Blog/Blog';
import Motorx from './components/OilChange/Motorx/Blog/Blog';
import PrivateRoute from './components/Login/PrivateRoute/PrivateRoute';
export const UserContext = createContext();
const App = () => {
  const [loggedInUser, setLoggedInUser] = useState({});
  const [admin, setAdmin] = useState(false);
  return (
    <UserContext.Provider
      value={[loggedInUser, setLoggedInUser, admin, setAdmin]}
    >
      <Router>
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/oil">
            <Oil />
          </Route>
          <Route path="/oil-change/ipone">
            <Ipone />
          </Route>
          <Route path="/oil-change/motul">
            <Motul />
          </Route>
          <Route path="/oil-change/motorx">
            <Motorx />
          </Route>
          <PrivateRoute path="/admin">
            <Dashboard />
          </PrivateRoute>
          <PrivateRoute path="/admin/book/:id">
            <Book />
          </PrivateRoute>
          <PrivateRoute path="/admin/book-list">
            <BookingList />
          </PrivateRoute>
        </Switch>
      </Router>
    </UserContext.Provider>
  );
};

export default App;
